import { createConsumer } from "@rails/actioncable"

let cable: ReturnType<typeof createConsumer> | null = null

function devCableBaseUrl(): string | null {
  if (process.env.NODE_ENV !== "development") return null
  if (!process.env.NEXT_PUBLIC_CABLE_VIA_REWRITE) return null
  if (typeof window === "undefined") return null
  return window.location.origin
}

export function getCable(token: string) {
  if (!cable) {
    const baseUrl =
      devCableBaseUrl() || process.env.NEXT_PUBLIC_API_URL?.replace("/api/", "") || "http://localhost:3000"
    const cableUrl = `${baseUrl.replace(/^http/, "ws")}/cable?token=${token}`
    cable = createConsumer(cableUrl)
  }
  return cable
}

export function disconnectCable() {
  if (cable) {
    cable.disconnect()
    cable = null
  }
}
